<!--  -->
<template>
  <van-popup
    class="popup"
    v-model="show"
    :round="true"
    :close-on-click-overlay="false"
  >
    <div
      class="share"
      ref="imageWrapper"
      v-show="!imgUrl"
    >
      <div class="share-head">
        <img
          src="https://ark-prod-cdn-images.iqihang.com/image/20221220/68a0f304912144438ee0c53a16dadff7.png"
          alt=""
        />
        <div class="head-img">
          <img :src="userInfo.avatar || require('../../../assets/img/defaultAvatar.png')" />
          <div>
            <span>亲爱的 {{ userInfo.nickName || userInfo.userName }}</span>
            <div class="headTime">陪伴启航已经<span>{{studyInfo.registerDay||0}}</span>天了</div>
          </div>
        </div>
      </div>
      <section class="section">
        <StudyProgress
          :studyInfo="studyInfo"
          :showShare="true"
        />
        <div class="bottom-tips">
          <div>{{quotesSentence}}</div>
        </div>
        <div class="qihang">
          <template v-if="hasPullNewActivity">
            <h2>拉新赢好礼，快去分享吧</h2>
            <img
              v-if="currentQrcode"
              class="code"
              :src="currentQrcode"
            />
          </template>
          <template v-else>
            <img
              class="logo"
              src="https://ark-test-cdn-images.iqihang.com/image/20220805/dd40849f0bfe45fc9c6a997cfabfeaaa.png"
            />
            <img
              class="code"
              :src="currentQrcode"
            />
          </template>

        </div>
      </section>
    </div>
    <div
      class="share"
      v-show="imgUrl"
    >
      <img
        class="poster"
        :src="imgUrl"
        alt=""
      />
    </div>
    <!-- <div
      class="share-btn"
      @click="close"
      v-if="!this.$root.isApp"
    >
      <span>长按或截图保存图片</span>
      <img
        src="../../../assets/img/learningGuidePage/report-share-btn.png"
        alt=""
      />
    </div> -->
  </van-popup>
</template>

<script>
import { mapState } from 'vuex';
import html2canvas from 'html2canvas';
import QRCode from 'qrcode';
import { reqTypeList } from '@/api/home';
import { getPullNewInfoApi, pushShareStatusApi } from '@/api/pullNew';
import StudyProgress from './studyProgress.vue';

export default {
  components: {
    StudyProgress,
  },
  data() {
    return {
      show: true,
      qrcode: '',
      pullNewQrcode: '',
      imgUrl: null,
    };
  },
  props: {
    studyInfo: {
      type: Object,
      default: () => { },
    },
    pullNewList: {
      type: Object,
      default: () => { },
    },
    quotesSentence: String,
  },
  computed: {
    ...mapState(['userInfo']),
    hasPullNewActivity() {
      return Boolean(this.pullNewList?.activityId);
    },
    currentQrcode() {
      if (this.hasPullNewActivity && this.pullNewQrcode) {
        return this.pullNewQrcode;
      }
      return this.qrcode;
    },
  },
  watch: {},
  methods: {
    async initSharePoster() {
      await this.getTypeList();
      await this.getPullNewCode();
      await new Promise((resolve) => {
        this.$nextTick(resolve);
      });
      await this.waitForWrapperImages();
      this.toImage();
    },
    // 获取分类列表
    async getTypeList() {
      const res = await reqTypeList('STUDY_REPORT_CODE');
      if (res.code === 0 && res.data?.length) {
        this.qrcode = res.data[0].remark;
      }
    },
    waitForImage(imageElement) {
      return new Promise((resolve) => {
        if (!imageElement) {
          resolve();
          return;
        }
        if (imageElement.complete) {
          resolve();
          return;
        }
        const handleDone = () => {
          imageElement.removeEventListener('load', handleDone);
          imageElement.removeEventListener('error', handleDone);
          resolve();
        };
        imageElement.addEventListener('load', handleDone, { once: true });
        imageElement.addEventListener('error', handleDone, { once: true });
      });
    },
    async waitForWrapperImages() {
      const imageList = Array.from(this.$refs.imageWrapper?.querySelectorAll('img') || []);
      await Promise.all(imageList.map((item) => this.waitForImage(item)));
    },
    toImage() {
      html2canvas(this.$refs.imageWrapper, {
        dpi: 300,
        useCORS: true,
        backgroundColor: 'transparent', // 圆角问题

      }).then((canvas) => {
        const dataURL = canvas.toDataURL('image/png', 1.0);
        this.imgUrl = dataURL;
        // app内分享
        if (this.$root.isApp) {
          this.$sendToApp(
            'shareStudyReport',
            {
              url: this.imgUrl,
              title: '学习报告',
              content: '',
              icon: '',
            },
            false,
          );
        }
      });
    },

    close() {
      this.$parent.showShare = false;
    },

    async getPullNewCode() {
      if (!this.hasPullNewActivity) return;
      const { activityId } = this.pullNewList;
      const res = await getPullNewInfoApi(activityId, 0);
      if (res?.code === 0) {
        const { isGenerateShare, encryptionKey } = res?.data?.pullNewActivityShareData;
        if (!encryptionKey) return;
        this.pullNewQrcode = await this.creatQrCode(activityId, encryptionKey);
        if (!isGenerateShare) {
          // 没生成活动分享图
          this.pushShareStatus(activityId);
        }
      }
    },
    async creatQrCode(activityId, encryptionKey) {
      const url = `${window.location.origin}/ark/pullnew/helper/?activityId=${activityId}&key=${encryptionKey}&pullNewType=${this.$root.pullNewType===2?'yt':''}&miniSource=${this.$root.ytMini?'yt':''}`;
      console.log('创建二维码', url);
      const qrcodeUrl = await QRCode.toDataURL(url, {
        margin: 1,
        text: url,
        width: 105,
        errorCorrectionLevel: 'L',
      });
      console.log('创建二维码成功了', qrcodeUrl);
      return qrcodeUrl;
    },
    pushShareStatus(activityId) {
      // 更新用户是否分享过
      pushShareStatusApi(activityId);
    },
  },
  created() {
    this.initSharePoster();
  },
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    // 分享按钮
    window['iqhApp2jsBridge.triggerSC'].closeShareReport = this.close;
  },
};
</script>
<style lang="scss" scoped>
.popup {
  background: none;
  border-radius: 36px !important;
}
.share {
  position: relative;
  width: 714px;
  height: 1030px;
  background: linear-gradient(180deg, #ff6b00 0%, #ff9e6f 100%);
  border-radius: 36px;
  .share-head {
    width: 100%;
    height: 326px;
    > img {
      width: 100%;
    }
    .head-img {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 36px 0 0 38px;
      > img {
        width: 109px;
        height: 109px;
        margin-right: 22px;
        border: 5px solid #fff;
        border-radius: 50%;
      }
      > div {
        > span {
          display: inline-block;
          width: 350px;
          overflow: hidden;
          color: #fff;
          font-weight: 500;
          font-size: 29px;
          line-height: 40px;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .headTime {
          margin-bottom: 14px;
          color: #fff;
          font-weight: 400;
          font-size: 25px;
          line-height: 36px;
          span {
            margin: 0 4px;
            padding: 0 7px;
            color: #ff7f41;
            font-weight: 600;
            font-size: 25px;
            line-height: 36px;
            background: #fff;
            border-radius: 18px;
          }
        }
      }
    }
  }
  .section {
    position: absolute;
    top: 181px;
    left: 18px;
    width: 678px;
    height: 830px;
    background: #fff;
    border-radius: 36px;
    .study-progress {
      width: 612px;
      margin: 0 33px;
      padding: 36px 0 0 0;
      border-radius: 0;
    }
    .bottom-tips {
      position: absolute;
      bottom: 188px;
      left: 0;
      width: 100%;
      div {
        box-sizing: border-box;
        width: 608px;
        height: 45px;
        margin: 0 auto;
        color: #fff;
        font-weight: 400;
        font-size: 25px;
        line-height: 45px;
        text-align: center;
        background: url(../../../assets/img/personalImg/subjectBg.png) no-repeat;
        background-size: 100% 100%;
      }
    }
    .qihang {
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 678px;
      height: 168px;
      padding: 0 54px 0 45px;
      background: #f1f6ff;
      border-radius: 0 0 36px 36px;
      .logo {
        width: 199px;
      }
      .code {
        width: 105px;
        height: 105px;
      }
      h2 {
        color: #333;
        font-weight: 400;
        font-size: 28px;
        line-height: 36px;
      }
    }
  }
  .poster {
    width: 100%;
  }
}
.share-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    color: #fff;
    font-weight: 500;
    font-size: 29px;
  }
  img {
    width: 98px;
    height: 82px;
  }
}
</style>
